const DEFAULT_APPROX_TOKENS_PER_CHAR = 0.3;

export const tokenCounter = (input) => {
  try {
    if (typeof input === 'string') {
      return Math.ceil((input?.length || 0) * DEFAULT_APPROX_TOKENS_PER_CHAR);
    }
    if (Array.isArray(input)) {
      const totalChars = input.reduce((acc, m) => acc + (m?.content?.length || 0), 0);
      return Math.ceil(totalChars * DEFAULT_APPROX_TOKENS_PER_CHAR);
    }
  } catch (error) {
    console.error('Error counting tokens:', error);
    return 0;
  }

  return 0;
}
